// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SierraService {
   $rootScope: any
   $http: any
   i18n: any
   $log: any
   $q: any
   $timeout: any
   $authEvents: any
   activationStatusIsEditable: any
   alerts: any
   auth: any
   authConfig: any
   authFeature: any
   baseUrl: any
   branches: any
   checkDigit: any
   configService: any
   locations: any
   multiplied: any
   multiplier: any
   newRequestMade: any
   patronInfoLoadedPromise: any
   previousHoldRequestId: any
   provider: any
   userInfo: any
   libraryCardUnavailable: boolean
   
   constructor($rootScope: any, $http: any, authenticationService: any, configService: any, alertService: any, $authEvents: any, $log: any, $q: any, $timeout: any, i18n: any) {
      this.logoutHandler = this.logoutHandler.bind(this)
      this.loginHandler = this.loginHandler.bind(this)
      this.mapSierraBibIdToSummonParticipantId = this.mapSierraBibIdToSummonParticipantId.bind(this)
      this.transformBibId = this.transformBibId.bind(this)
      this.createAlwaysSuccessPromise = this.createAlwaysSuccessPromise.bind(this)
      this.handleError = this.handleError.bind(this)
      this.$rootScope = $rootScope
      this.$http = $http
      this.configService = configService
      this.i18n = i18n
      this.$log = $log
      this.$q = $q
      this.$timeout = $timeout
      this.$authEvents = $authEvents
      this.auth = authenticationService
      this.baseUrl = '/sierra_api'
      this.userInfo = null
      this.alerts = alertService
      this.previousHoldRequestId = null
      this.activationStatusIsEditable = true
      this.alerts.resetAlert('sierraApiError')
      this.locations = {}
      this.branches = []
      this.newRequestMade = false
      this.provider = ''
      this.patronInfoLoadedPromise = this.$q.defer()
      this.libraryCardUnavailable = false 
      // only register if we're active client - should we do this on init?
      if (this.configService.data.libraryCard.enableSierra) {
         this.authConfig = this.configService.data.authentication
         this.authFeature = authenticationService.registerFeature('sierra', "LIBRARY_CARD_FEATURE")
         if (_.includes(['CAS', 'Both'], this.authConfig.sierraAuthProtocol)) { this.authFeature.setProvider('cas',{}) }
         if (_.includes(['SAML', 'Both'], this.authConfig.sierraAuthProtocol)) { this.authFeature.setProvider('saml',{}) }
         // this.authFeature.setProvider('lti',{})
         $rootScope.$on($authEvents.LOGINSUCCESS, (event: any, args: any) => {
            if (!this.auth.providerSupportsFeature(args.provider, 'sierra')) {
               return
            }
            this.provider = args.provider
            return this.loginHandler(args.provider)
         })
      
         $rootScope.$on($authEvents.LOGOUTSUCCESS, (event: any, args: any) => {
            if (!this.auth.providerSupportsFeature(args.provider, 'sierra')) {
               return
            }
            this.provider = ''
            return this.logoutHandler(args.provider)
         })
      }
   }

   logoutHandler(provider: any) {
      this.userInfo = null
      this.auth.setUserNameForProvider('', provider)
      this.auth.setEmailForProvider('', provider)
      this.auth.setUserNameForBanner('')
      this.auth.setSierraPatronIdForProvider('', provider)
      return this.patronInfoLoadedPromise = this.$q.defer()
   }

   loginHandler(provider: any) {
      // get patron data when user is logged in
      return this.getInitialSessionData()
         .then((userData: any) => {
            this.userInfo = userData.data
            this.auth.setUserNameForProvider(this.userInfo.username, provider)
            this.auth.setEmailForProvider(this.userInfo.email, provider)
            this.auth.setUserNameForBanner(this.userInfo.username)
            this.auth.setSierraPatronIdForProvider(this.userInfo.id, provider)
            this.libraryCardUnavailable = false 
            // if auth info was provided by init endpoint, put new info in local storage
            if (this.userInfo.auth) {
               const refreshOnly = true
               const data: any = {
                  user: this.userInfo.auth.uid,
                  expiry: this.userInfo.auth.expiry,
                  csrf: this.userInfo.auth.csrf,
                  provider,
                  access_token: this.userInfo.auth.access_token,
                  access_expiry: this.userInfo.auth.access_expiry,
                  display_name: this.userInfo.auth.display_name
               }
               this.auth.afterLogIn(provider, data, refreshOnly)
            }
        
            return this.patronInfoLoadedPromise.resolve()
         }).catch((err: any) => {
            this.$log.error('Could not get user data via Sierra service', err.data)
            this.libraryCardUnavailable = true
            this.$rootScope.$broadcast(this.$authEvents.SIERRA_LOGIN_FAILED, {
               provider,
               error: err
            })
            return this.patronInfoLoadedPromise.reject(err)
         })
   }

   // TODO - we could maybe also use $resource for this? https://docs.angularjs.org/api/ngResource/service/$resource

   // TODO error handling for GET requests, if not 401, handle here (?) (or in caller?)
   getInitialSessionData() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getLoggedInUser()}/init/${this.provider}`)
   }

   isUserInfoNull() {
      return this.userInfo === null
   }

   getLoadedUserInfo() {
      return this.userInfo
   }

   // expose information to controller so that requests list can be refreshed
   isNewRequestMade() {
      return this.newRequestMade
   }

   // let controller reset this flag in false to be able to watch for new changes
   resetNewRequestTracker() {
      return this.newRequestMade = false
   }

   getHoldRequestByBibId(bibId: any) {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}/holds/requests/form?recordNumber=${bibId}`, {cache: true})
   }

   getItemsInfo(itemIds: any) {
      if (angular.isArray(itemIds)) {
         itemIds = itemIds.join(',')
      }
      
      return this.$http.get(`${this.baseUrl}/items?fields=varFields&id=${itemIds}`)
   }

   getItemByItemId(itemId: any) {
      return this.$http.get(`${this.baseUrl}/items?id=${itemId}`)
   }

   getItemByBibId(bibId: any){
      return this.$http.get(`${this.baseUrl}/bibs/${bibId}`)
   }

   getHolds() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}/holds?expand=record`)
   }

   deleteHold(id: any) {
      return this.$http.delete(`${this.baseUrl}/patrons/${this.getPatronId()}/holds/${encodeURIComponent(id)}`)
   }

   getCheckouts() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}/checkouts?expand=item`)
   }

   renewCheckout(id: any) {
      return this.$http.post(`${this.baseUrl}/patrons/${this.getPatronId()}/checkouts/${encodeURIComponent(id)}`)
   }

   getRedirectLinkToSierraFinePage(){
      const originalUrl = this.configService.data.rtaAvailability.dbs[0]?.availabilityLink?.url
      const url = new URL(originalUrl)
      const trimmedUrl = `${url.protocol}//${url.host}`
      return `${trimmedUrl}/patroninfo~S01/${this.getPatronId()}/overdues`
   }

   updateUserDetails(details: any) {
      return this.$http.put(`${this.baseUrl}/patrons/${this.getPatronId()}`, details)
   }

   getReadingHistoryIfActivatedOrInferrable() {
      return this.getReadingHistoryActivationStatus().then((res: any) => {
         if (res.data.readingHistoryActivation) {
            if (res.data.inferred) {
               this.activationStatusIsEditable = false
            }
            return this.getReadingHistory()
         } else { return this.$q.resolve(res) }
      })
   }

   getReadingHistory() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}/checkouts/history`)
   }

   getReadingHistoryActivationStatus() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}/checkouts/history/activationStatus`)
   }

   optInToReadingHistory() {
      const params = { "readingHistoryActivation": true }
      return this.updateReadingHistoryActivation(params)
   }

   optOutFromReadingHistory() {
      const params = { "readingHistoryActivation": false }
      return this.updateReadingHistoryActivation(params)
   }

   getWebPacReadingHistoryOptInLink() {
      if (this.configService.data.libraryCard.webpacPatronInfoUrl.length) {
         return `${this.configService.data.libraryCard.webpacPatronInfoUrl}/${this.getPatronId()}/readinghistory/OptIn`
      }
      return ""
   }

   deleteReadingHistoryAndOptOut() {
      return this.deleteAllReadingHistoryEntries().then(() => {
         return this.optOutFromReadingHistory()
      })
   }

   updateReadingHistoryActivation(params: any) {
      return this.$http.post(`${this.baseUrl}/patrons/${this.getPatronId()}/checkouts/history/activationStatus`, params)
   }

   deleteReadingHistoryEntry(id: any) {
      return this.$http.delete(`${this.baseUrl}/patrons/${this.getPatronId()}/checkouts/history/${encodeURIComponent(id)}`)
   }

   deleteAllReadingHistoryEntries() {
      return this.$http.delete(`${this.baseUrl}/patrons/${this.getPatronId()}/checkouts/history`)
   }

   getFines() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}/fines?expand=item`)
   }

   getExternalMessages() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}?fields=message`)
   }

   getMessages() {
      return this.userInfo.message.accountMessages || []
   }

   getLoggedInUser() {
      return this.auth.getUserForProvider(this.provider)
   }

   userIdentifierIsMail() {
      return /@/g.test(this.getLoggedInUser())
   }

   getPatronId() {
      // if other providers used, we can change mapping here
      return this.auth.getSierraPatronIdForProvider(this.provider)
   }

   getOrRenewPatronInfo() {
      if (!this.userInfo) { // if there were an error first time calling login handler
         // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
         return this.loginHandler()
      } else {
         return this.renewPatronInfo()
      }
   }

   // get and locally update fields that are both editable and readable, intended to be called after user edits patron object
   renewPatronInfo() {
      return this.$http.get(`${this.baseUrl}/patrons/${this.getPatronId()}?fields=emails,phones,addresses`)
         .then((data: any) => {
            const resp = data.data
            const email = resp.emails?.length ? resp.emails[0] : ""
            this.auth.setEmailForProvider(email, this.provider)
            this.userInfo.email = email
            this.userInfo.emails = resp.emails
            this.userInfo.phones = resp.phones
            return this.userInfo.addresses = resp.addresses
         })
   }

   createHoldRequest(hold: any, bibId: any) {
      this.previousHoldRequestId = null
      return this.$http.post(`${this.baseUrl}/patrons/${this.getPatronId()}/holds/requests`, hold)
         .then(() => { 
            this.previousHoldRequestId = bibId
            return this.newRequestMade = true
         })
   }

   updateHold(holdId: any, hold: any) {
      return this.$http.put(`${this.baseUrl}/patrons/${this.getPatronId()}/holds/${holdId}`, hold)
   }

   getIdFromUrlString(urlString: any) { 
      const idx = urlString.lastIndexOf('/')
      return urlString.substring(idx+1)
   }

   getCatalogIdPrefix() {
      const dbidFromSierra = _(this.configService.data.rtaAvailability.dbs)
         .filter((p: any) => p.availabilityLink?.ilsType.indexOf('SierraApiHttpConnector') !== -1)[0]
      if (dbidFromSierra && (dbidFromSierra.idPrefix != null)) {
         return dbidFromSierra.idPrefix
      } else { 
         return `${this.configService.data.rtaAvailability.client}_catalog_`
      }
   }

   getBibIdCheckDigit(bibId: any) {
      this.multiplier = 1
      this.multiplied = _.map(bibId.split("").reverse(), (char: any) => { 
         this.multiplier++
         return parseInt(char) * this.multiplier
      })

      this.checkDigit = this.multiplied.reduce((memo: any, num: any) => memo + num) % 11

      if (this.checkDigit !== 10) { return this.checkDigit } else { return "x" }
   }

   mapSierraBibIdToSummonParticipantId(sierraDocBibId: any) {
      return `${this.getCatalogIdPrefix()}b${sierraDocBibId}${this.getBibIdCheckDigit(sierraDocBibId)}`
   }

   createApiQuery(rawBibIds: any, bibIdIsOptional = false) {
      if (bibIdIsOptional) {
         rawBibIds = _.filter(rawBibIds, (item: any) => item.bibId)
      }
      const bibIds = _.map(rawBibIds, (item: any) => item.bibId)
      if (bibIds.length > 0) {
         const apiQuery = {
            solrPassThroughQuery: this.createBibIdQuery(bibIds),
            ho: false,
            pn: 0, // this makes it show no facets (will be a bit faster, we don't use facets)
            ps: bibIds.length // make sure for larger request we get all documents at once - note that we might run into issues for very large requests, we'll need paging...
         }
         return apiQuery
      } else {
         return false
      }
   }

   createBibIdQuery(bibIds: any) {
      return _.map(bibIds, (bibId: any) => `(sys_participant_id:(${this.mapSierraBibIdToSummonParticipantId(bibId)}))`).join(" OR ") // with check digit
      + " OR " 
      + _.map(bibIds, (bibId: any) =>  `(sys_participant_id:(${bibId}))`).join(" OR ") // without check digit
      
   }

   // returns doc if exists or undefined
   findDocIfExists(apiDocs: any, sierraDocBibId: any) {
      // merges docs & peer-docs. It might be that a peer_doc was used, so we want to return this specific peer-doc to the output for displaying
      // I can imagine a peer_doc might have a different publisher year or something, not sure, but this should avoid weirdness there
      const allDocs = _.flatten(apiDocs.concat(apiDocs.map((doc: any) => doc.peer_documents)))
      return _.find(allDocs, (doc: any) => {
         if (!doc) { 
            return false
         }
         if (_.any(doc.participant_ids, (participantId: any) => participantId === this.mapSierraBibIdToSummonParticipantId(sierraDocBibId)) ) {
            return true
         } else if ((`b${sierraDocBibId}${this.getBibIdCheckDigit(sierraDocBibId)}` === doc.external_document_id) || (`b${sierraDocBibId}` === doc.external_document_id)) {
            return true
         }
      })
   }

   createDummyDoc(missingDocDisplay: any) {
      return {
         content_type: '',
         display_thumbnail: '',
         missingDocDisplay
      }
   }

   transformBibId(bibId: any) {
      // Get availabilityLink with ilsType: SierraApiHttpConnector. Can it be done less hardcoded?
      const transform = _(this.configService.data.rtaAvailability.dbs)
         .filter((p: any) => p.availabilityLink?.ilsType.indexOf('SierraApiHttpConnector') !== -1)[0]

      if ((transform.availabilityLink.idPattern != null) && (transform.availabilityLink.idReplacement != null)) {
         const idPattern = new RegExp(transform.availabilityLink.idPattern)

         return bibId.replace(idPattern, transform.availabilityLink.idReplacement)
      }

      return bibId
   }

   // this is a wrapper that returns a promise that resolves, even if it was rejected.
   // made because further down the code uses $q.all() which returns immediately if one of the promises rejects.
   // using .all() for multiple cancel requests, where 1 of the request fails causes strange behavior, because the code will run without knowing which
   // items are resolved and which are not. This works around that by always resolving, and returning some extra data in the object that is returned.
   createAlwaysSuccessPromise(promise: any, id: any) { 
      const deferred = this.$q.defer()
      promise.then((data: any) => { 
         const newData = { 
            original: data,
            status: 'success',
            holdId: id
         }
         return deferred.resolve(newData)
      }).catch((err: any) => {
         const newData = { 
            original: err,
            status: 'error',
            holdId: id
         }
         return deferred.resolve(newData)
      })
      return deferred.promise
   }

   handleError(err: any) {
      this.$log.error(err)
      return this.alerts.setAlert('sierraApiError', 'Error performing API request.')
   }
}

SierraService.$inject = ['$rootScope', '$http', 'authenticationService', 'configService', 'alertService', '$authEvents', '$log', '$q', '$timeout']

angular.module('summonApp.services')
   .service('sierraService', SierraService)
